module.exports = __webpack_public_path__ + "assets/img/Logitech-VC-Australia-Website.4ad8f953.webp";